import React from 'react';

import { FlyoutTrigger } from '@atlassian/entry-point-flyout';
import type { ObjectListFlyoutProps } from '@atlassian/navigation-common/types';

import { objectListFlyoutEntrypoint } from './object-list-flyout-content/objectListFlyout.entrypoint';

/**
 * Component that renders a list of items in a flyout menu with searching & filtering capabilities in the list.
 * Consumers can provide the items data via the useItems hook.
 */
export function ObjectListFlyout(props: ObjectListFlyoutProps): React.JSX.Element {
	// We are NOT destructuring all of the properties in `props`.
	// There are extra properties (e.g. props.actions) which are being passed to the entrypoint
	const {
		dropIndicator,
		elemBefore,
		entryPoint = objectListFlyoutEntrypoint,
		entryPointParams,
		errorFallback,
		fallback,
		hasDragIndicator,
		isDefaultOpen,
		isDragging,
		isFlyoutOpen,
		isSelected,
		label,
		labelElem,
		onClick,
		onOpenChange,
		testId,
		triggerRef,
		visualContentRef,
	} = props;

	return (
		<FlyoutTrigger
			entryPoint={entryPoint}
			entryPointProps={props}
			entryPointParams={entryPointParams}
			errorFallback={errorFallback}
			fallback={fallback}
			isDefaultOpen={isDefaultOpen}
			isFlyoutOpen={isFlyoutOpen}
			onOpenChange={onOpenChange}
			triggerProps={{
				elemBefore,
				children: labelElem ?? label,
				isSelected,
				onClick,
				testId,
				hasDragIndicator,
				isDragging,
				dropIndicator,
				triggerRef,
				visualContentRef,
			}}
		/>
	);
}
